export const MULTI_OPENING_PRODUCTS = [
  {
    id: 'mo-3v4x6-11x20',
    name: "3 V 4x6's in 11x20 Mat/Frame",
    matWidth: 20,
    matHeight: 11,
    validPrintSizes: ['4x6'],
    openingShape: 'oval',
    layout: 'row',
    openings: [
      { id: 1, printWidth: 4.5, printHeight: 7 },
      { id: 2, printWidth: 4.5, printHeight: 7 },
      { id: 3, printWidth: 4.5, printHeight: 7 },
    ],
  },
  {
    id: 'mo-2v4x6-1h6x9-11x25',
    name: "2 V 4x6's & H 6x9 in 11x25 Mat/Frame",
    matWidth: 25,
    matHeight: 11,
    validPrintSizes: ['4x6', '6x9'],
    layout: 'custom',
    openings: [
      { id: 1, printWidth: 4, printHeight: 6, left: 10, top: 23, width: 16, height: 55 },
      { id: 2, printWidth: 9, printHeight: 6, left: 32, top: 23, width: 36, height: 55 },
      { id: 3, printWidth: 4, printHeight: 6, left: 74, top: 23, width: 16, height: 55 },
    ],
  },
  {
    id: 'mo-3s5x5-10x23',
    name: "3 5x5's in 10x23 Mat/Frame",
    matWidth: 23,
    matHeight: 10,
    validPrintSizes: ['5x5'],
    openingShape: 'circle',
    layout: 'row',
    openings: [
      { id: 1, printWidth: 5, printHeight: 5 },
      { id: 2, printWidth: 5, printHeight: 5 },
      { id: 3, printWidth: 5, printHeight: 5 },
    ],
  },
  {
    id: 'mo-3v5x7-12x23',
    name: "3 V 5x7's in 12x23 Mat/Frame",
    matWidth: 23,
    matHeight: 12,
    validPrintSizes: ['5x7'],
    openingShape: 'oval',
    layout: 'row',
    openings: [
      { id: 1, printWidth: 5, printHeight: 7.5 },
      { id: 2, printWidth: 5, printHeight: 7.5 },
      { id: 3, printWidth: 5, printHeight: 7.5 },
    ],
  },
  {
    id: 'mo-4s5x5-16x16',
    name: "4 5x5's in 16x16 Mat/Frame",
    matWidth: 16,
    matHeight: 16,
    validPrintSizes: ['5x5'],
    openingShape: 'circle',
    layout: 'grid-2x2',
    borderInches: 2.5,
    openings: [
      { id: 1, printWidth: 5, printHeight: 5 },
      { id: 2, printWidth: 5, printHeight: 5 },
      { id: 3, printWidth: 5, printHeight: 5 },
      { id: 4, printWidth: 5, printHeight: 5 },
    ],
  },
  {
    id: 'mo-4v5x7-12x29',
    name: '4 V 5x7s in 12x29 Mat/Frame',
    matWidth: 29,
    matHeight: 12,
    validPrintSizes: ['5x7'],
    openingShape: 'oval',
    layout: 'row',
    openings: [
      { id: 1, printWidth: 5, printHeight: 7 },
      { id: 2, printWidth: 5, printHeight: 7 },
      { id: 3, printWidth: 5, printHeight: 7 },
      { id: 4, printWidth: 5, printHeight: 7 },
    ],
  },
  {
    id: 'mo-2v5x7-1h7x10-12x28',
    name: "2 V 5x7's & H 7x10 in 12x28 Mat/Frame",
    matWidth: 28,
    matHeight: 12,
    validPrintSizes: ['5x7', '7x10'],
    layout: 'custom',
    openings: [
      { id: 1, printWidth: 5, printHeight: 7, left: 9, top: 21, width: 18, height: 58 },
      { id: 2, printWidth: 10, printHeight: 7, left: 32, top: 21, width: 36, height: 58 },
      { id: 3, printWidth: 5, printHeight: 7, left: 73, top: 21, width: 18, height: 58 },
    ],
  },
  {
    id: 'mo-6v4x6-18x20',
    name: '6 V 4x6s in 18x20 Mat/Frame',
    matWidth: 20,
    matHeight: 18,
    validPrintSizes: ['4x6'],
    openingShape: 'oval',
    layout: 'grid-3x2',
    borderInches: 2.5,
    openings: [
      { id: 1, printWidth: 4, printHeight: 6 },
      { id: 2, printWidth: 4, printHeight: 6 },
      { id: 3, printWidth: 4, printHeight: 6 },
      { id: 4, printWidth: 4, printHeight: 6 },
      { id: 5, printWidth: 4, printHeight: 6 },
      { id: 6, printWidth: 4, printHeight: 6 },
    ],
  },
  {
    id: 'mo-3v6x9-14x26',
    name: "3 V 6x9's in 14x26 Mat/Frame",
    matWidth: 26,
    matHeight: 14,
    validPrintSizes: ['6x9'],
    openingShape: 'oval',
    layout: 'row',
    openings: [
      { id: 1, printWidth: 6, printHeight: 9 },
      { id: 2, printWidth: 6, printHeight: 9 },
      { id: 3, printWidth: 6, printHeight: 9 },
    ],
  },
  {
    id: 'mo-3s5x5-3v5x7-20x24',
    name: "3 5x5's & 3 5x7's in 20x24 Mat/Frame",
    matWidth: 24,
    matHeight: 24,
    validPrintSizes: ['5x5', '5x7'],
    layout: 'custom',
    openings: [
      { id: 1, printWidth: 5, printHeight: 5, left: 13.8, top: 15.8, width: 21.0, height: 25.2 },
      { id: 2, printWidth: 5, printHeight: 7, left: 39.5, top: 15.8, width: 21.0, height: 35.8 },
      { id: 3, printWidth: 5, printHeight: 5, left: 65.2, top: 15.8, width: 21.0, height: 25.2 },
      { id: 4, printWidth: 5, printHeight: 7, left: 13.8, top: 45.3, width: 21.0, height: 35.8 },
      { id: 5, printWidth: 5, printHeight: 5, left: 39.5, top: 55.2, width: 21.0, height: 25.2 },
      { id: 6, printWidth: 5, printHeight: 7, left: 65.2, top: 45.3, width: 21.0, height: 35.8 },
    ],
  },
  {
    id: 'mo-3s8x8-13x32',
    name: "3 8x8's in 13x32 Mat/Frame",
    matWidth: 32,
    matHeight: 13,
    validPrintSizes: ['8x8'],
    openingShape: 'circle',
    layout: 'row',
    openings: [
      { id: 1, printWidth: 8, printHeight: 8 },
      { id: 2, printWidth: 8, printHeight: 8 },
      { id: 3, printWidth: 8, printHeight: 8 },
    ],
  },
  {
    id: 'mo-3v8x12-17x32',
    name: "3 8x12's in 17x32 Mat/Frame",
    matWidth: 32,
    matHeight: 17,
    validPrintSizes: ['8x12'],
    layout: 'row',
    openings: [
      { id: 1, printWidth: 8, printHeight: 12 },
      { id: 2, printWidth: 8, printHeight: 12 },
      { id: 3, printWidth: 8, printHeight: 12 },
    ],
  },
  {
    id: 'mo-9s5x5-23x23',
    name: "9 5x5's in 23x23 Mat/Frame",
    matWidth: 24,
    matHeight: 24,
    validPrintSizes: ['5x5'],
    openingShape: 'circle',
    layout: 'grid-3x3',
    borderInches: 3,
    openings: [
      { id: 1, printWidth: 5, printHeight: 5 },
      { id: 2, printWidth: 5, printHeight: 5 },
      { id: 3, printWidth: 5, printHeight: 5 },
      { id: 4, printWidth: 5, printHeight: 5 },
      { id: 5, printWidth: 5, printHeight: 5 },
      { id: 6, printWidth: 5, printHeight: 5 },
      { id: 7, printWidth: 5, printHeight: 5 },
      { id: 8, printWidth: 5, printHeight: 5 },
      { id: 9, printWidth: 5, printHeight: 5 },
    ],
  },
  {
    id: 'mo-4s8x8-22x22',
    name: "4 8x8's in 22x22 Mat/Frame",
    matWidth: 22,
    matHeight: 22,
    validPrintSizes: ['8x8'],
    openingShape: 'circle',
    layout: 'grid-2x2',
    borderInches: 2.6,
    openings: [
      { id: 1, printWidth: 8, printHeight: 8 },
      { id: 2, printWidth: 8, printHeight: 8 },
      { id: 3, printWidth: 8, printHeight: 8 },
      { id: 4, printWidth: 8, printHeight: 8 },
    ],
  },
  {
    id: 'mo-9v5x7-24x30',
    name: "9 V 5x7's in 24x30 Mat/Frame",
    matWidth: 24,
    matHeight: 30,
    validPrintSizes: ['5x7'],
    openingShape: 'oval',
    layout: 'grid-3x3',
    borderInches: 3.5,
    openings: [
      { id: 1, printWidth: 5, printHeight: 7 },
      { id: 2, printWidth: 5, printHeight: 7 },
      { id: 3, printWidth: 5, printHeight: 7 },
      { id: 4, printWidth: 5, printHeight: 7 },
      { id: 5, printWidth: 5, printHeight: 7 },
      { id: 6, printWidth: 5, printHeight: 7 },
      { id: 7, printWidth: 5, printHeight: 7 },
      { id: 8, printWidth: 5, printHeight: 7 },
      { id: 9, printWidth: 5, printHeight: 7 },
    ],
  },
];

export const findMultiOpeningProductByName = (name) => {
  if (!name) return null;
  const normalize = (text) => text.replace(/mat\/fame/gi, 'mat/frame').trim().toLowerCase();
  const target = normalize(name);
  return MULTI_OPENING_PRODUCTS.find((p) => normalize(p.name) === target) || null;
};

// Products that contain 5x7 prints → show Oval Deckle options
export const PRODUCTS_WITH_5X7 = MULTI_OPENING_PRODUCTS.filter((p) => p.validPrintSizes.includes('5x7')).map((p) => p.id);

// Products that contain 8x8 prints → show 8" circle deckled options
export const PRODUCTS_WITH_8X8 = MULTI_OPENING_PRODUCTS.filter((p) => p.validPrintSizes.includes('8x8')).map((p) => p.id);

/**
 * Computes the { left, top, width, height } rectangles (all as % of mat)
 * for a product's openings so the SVG visualization can render them.
 */
export const computeOpeningRects = (product) => {
  const { matWidth, matHeight, openings, layout } = product;

  if (layout === 'custom') {
    return openings;
  }

  if (layout === 'row') {
    const n = openings.length;
    const pw = openings[0].printWidth;
    const ph = openings[0].printHeight;
    const b = product.borderInches !== undefined ? product.borderInches : (matHeight - ph) / 2;
    const gap = n > 1 ? (matWidth - 2 * b - n * pw) / (n - 1) : 0;
    const topPct = (b / matHeight) * 100;
    const leftPct = (b / matWidth) * 100;
    const wPct = (pw / matWidth) * 100;
    const hPct = (ph / matHeight) * 100;
    const gPct = (gap / matWidth) * 100;
    return openings.map((opening, i) => ({
      ...opening,
      left: leftPct + i * (wPct + gPct),
      top: topPct,
      width: wPct,
      height: hPct,
    }));
  }

  if (layout === 'column') {
    const n = openings.length;
    const pw = openings[0].printWidth;
    const ph = openings[0].printHeight;
    const b = (matWidth - pw) / 2;
    const gap = n > 1 ? (matHeight - 2 * b - n * ph) / (n - 1) : 0;
    const leftPct = (b / matWidth) * 100;
    const topPct = (b / matHeight) * 100;
    const wPct = (pw / matWidth) * 100;
    const hPct = (ph / matHeight) * 100;
    const gPct = (gap / matHeight) * 100;
    return openings.map((opening, i) => ({
      ...opening,
      left: leftPct,
      top: topPct + i * (hPct + gPct),
      width: wPct,
      height: hPct,
    }));
  }

  // grid-2x2, grid-3x3, grid-3x2, grid-2x3
  const [cols, rows] = layout.replace('grid-', '').split('x').map(Number);
  const pw = openings[0].printWidth;
  const ph = openings[0].printHeight;

  let b, gH, gV;
  if (product.borderInches !== undefined) {
    b = product.borderInches;
    gH = cols > 1 ? (matWidth  - 2 * b - cols * pw) / (cols - 1) : 0;
    gV = rows > 1 ? (matHeight - 2 * b - rows * ph) / (rows - 1) : 0;
  } else if (product.gapInches !== undefined) {
    gH = product.gapInches;
    gV = product.gapInches;
    b = (matWidth - cols * pw - (cols - 1) * gH) / 2;
  } else if (cols !== rows) {
    const g = (matWidth - matHeight - cols * pw + rows * ph) / (cols - rows);
    b = (matWidth - cols * pw - (cols - 1) * g) / 2;
    gH = g;
    gV = g;
  } else {
    b = (matWidth - cols * pw) / (cols + 1);
    gH = b;
    gV = b;
  }

  const bLeftPct = (b / matWidth) * 100;
  const bTopPct = (b / matHeight) * 100;
  const wPct = (pw / matWidth) * 100;
  const hPct = (ph / matHeight) * 100;
  const gHPct = (gH / matWidth) * 100;
  const gVPct = (gV / matHeight) * 100;

  return openings.map((opening, i) => {
    const col = i % cols;
    const row = Math.floor(i / cols);
    return {
      ...opening,
      left: bLeftPct + col * (wPct + gHPct),
      top: bTopPct + row * (hPct + gVPct),
      width: wPct,
      height: hPct,
    };
  });
};

/**
 * Returns true if a print size text (from the API) is valid for the given product.
 * The API text is like "5x7 ($12.50)" or "4x6 ($8.00)".
 */
export const isPrintSizeValidForProduct = (sizeText, product) => {
  if (!product || !sizeText || !Array.isArray(product.validPrintSizes)) return false;
  return product.validPrintSizes.some((size) => sizeText.startsWith(size));
};

// Paper types that are deckled oval variants (only work in PRODUCTS_WITH_5X7)
export const isOvalDecklePaper = (text) => {
  const t = (text || '').toLowerCase();
  return t.includes('oval') && t.includes('deckle');
};

// Paper types that are 8" circle deckled (only work in PRODUCTS_WITH_8X8)
export const isCircleDecklePaper = (text) => {
  const t = (text || '').toLowerCase();
  return t.includes('circle') && t.includes('deckle');
};

export const getCenteredCrop = (imageWidth, imageHeight, targetAspect) => {
  const imageAspect = imageWidth / imageHeight;

  if (imageAspect > targetAspect) {
    const width = (targetAspect / imageAspect) * 100;
    return { x: (100 - width) / 2, y: 0, width, height: 100 };
  }

  const height = (imageAspect / targetAspect) * 100;
  return { x: 0, y: (100 - height) / 2, width: 100, height };
};
